export default __webpack_public_path__ + "static/media/logo1.ba30a290.png";